/**
 * Sending the pre-visit check-in form for an appointment by WhatsApp, SMS or email (doc 84). Only for
 * clinics on the ClinVea clinic software; the server decides which appointments qualify.
 */
import { fetchApi } from '../client';

export type ContactChannel = 'WHATSAPP' | 'SMS' | 'EMAIL';
export type ChannelAvailability = 'AVAILABLE' | 'NO_RECIPIENT' | 'NOT_SET_UP' | 'OPTED_OUT';
export type CheckinSendOutcome = 'SENT' | 'NOT_CONFIGURED' | 'NOT_AVAILABLE' | 'FAILED';
/** Why a channel was suggested: the booker chose it, the patient prefers it, the clinic's default, or the first that works. */
export type PreferenceSource = 'BOOKING' | 'PATIENT' | 'CLINIC' | 'DEFAULT';

export interface CheckinChannelOption {
  channel: ContactChannel;
  availability: ChannelAvailability;
  /** Masked number or email ("••••••3210", "r•••@example.com"); null when there is none. */
  recipient?: string | null;
}

export interface CheckinFormState {
  status: string;
  linkSentAt?: string | null;
  linkSentVia?: ContactChannel | null;
  expiresAt?: string | null;
}

export interface CheckinFormOptions {
  checkinEnabled: boolean;
  patientName?: string | null;
  when: string;
  status: string;
  channels: CheckinChannelOption[];
  suggested?: ContactChannel | null;
  suggestedBecause?: PreferenceSource | null;
  checkin?: CheckinFormState | null;
}

export interface CheckinFormResult {
  channel: ContactChannel;
  outcome: CheckinSendOutcome;
  /** The form link, returned whatever happened, so staff can share it themselves. */
  link: string;
  linkValidUntil?: string | null;
  message: string;
}

const id = (v: string) => encodeURIComponent(v);

export const checkinFormModule = {
  options: (tokenId: string) => fetchApi<CheckinFormOptions>(`/api/appointments/${id(tokenId)}/checkin-form`),
  send: (tokenId: string, body: { channel?: ContactChannel; email?: string }) =>
    fetchApi<CheckinFormResult>(`/api/appointments/${id(tokenId)}/checkin-form/send`, {
      method: 'POST', body: JSON.stringify(body), skipBodyLog: true,
    }),
};
